import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = { class: "title-block" }
const _hoisted_4 = { class: "subtitle-wrapper" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "tab-toggles" }
const _hoisted_7 = { class: "header-actions" }
const _hoisted_8 = { class: "date-tools" }
const _hoisted_9 = { class: "presets" }
const _hoisted_10 = ["disabled", "onClick"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "kpi-grid"
}
const _hoisted_13 = { class: "kpi-icon" }
const _hoisted_14 = { class: "kpi-body" }
const _hoisted_15 = { class: "kpi-title" }
const _hoisted_16 = {
  key: 0,
  class: "kpi-hint"
}
const _hoisted_17 = { class: "kpi-value" }
const _hoisted_18 = { class: "panel" }
const _hoisted_19 = { class: "panel-head static" }
const _hoisted_20 = { class: "panel-title" }
const _hoisted_21 = { class: "title-with-sub" }
const _hoisted_22 = { class: "desc" }
const _hoisted_23 = { class: "panel-body" }
const _hoisted_24 = {
  key: 0,
  class: "inline-loader"
}
const _hoisted_25 = {
  key: 1,
  class: "empty"
}
const _hoisted_26 = { class: "mini-stats" }
const _hoisted_27 = { class: "mini-stat" }
const _hoisted_28 = { class: "mini-stat" }
const _hoisted_29 = { class: "mini-stat" }
const _hoisted_30 = { class: "mini-stat" }
const _hoisted_31 = { class: "mini-stat" }
const _hoisted_32 = {
  key: 0,
  class: "single-bucket"
}
const _hoisted_33 = { class: "single-bucket-info" }
const _hoisted_34 = { class: "sb-label" }
const _hoisted_35 = { class: "sb-date" }
const _hoisted_36 = { class: "single-bucket-value" }
const _hoisted_37 = {
  key: 1,
  class: "chart-wrapper"
}
const _hoisted_38 = { class: "chart-legend" }
const _hoisted_39 = { class: "lg-item" }
const _hoisted_40 = {
  key: 0,
  class: "lg-tooltip"
}
const _hoisted_41 = { class: "chart-with-axes" }
const _hoisted_42 = { class: "y-axis" }
const _hoisted_43 = { class: "y-axis-caption" }
const _hoisted_44 = { class: "chart-area" }
const _hoisted_45 = { class: "bar-chart" }
const _hoisted_46 = { class: "avg-line-label" }
const _hoisted_47 = ["onMouseenter"]
const _hoisted_48 = { class: "bar-value" }
const _hoisted_49 = { class: "bar-x-axis" }
const _hoisted_50 = {
  key: 2,
  class: "empty"
}
const _hoisted_51 = {
  key: 3,
  class: "empty"
}
const _hoisted_52 = { class: "panel" }
const _hoisted_53 = { class: "panel-head static" }
const _hoisted_54 = { class: "panel-title" }
const _hoisted_55 = { class: "title-with-sub" }
const _hoisted_56 = { class: "desc" }
const _hoisted_57 = { class: "panel-body" }
const _hoisted_58 = {
  key: 0,
  class: "inline-loader"
}
const _hoisted_59 = {
  key: 1,
  class: "tod-layout"
}
const _hoisted_60 = { class: "donut-block" }
const _hoisted_61 = { class: "donut-center" }
const _hoisted_62 = { class: "donut-total" }
const _hoisted_63 = { class: "segments-list" }
const _hoisted_64 = { class: "segment-info" }
const _hoisted_65 = { class: "segment-top" }
const _hoisted_66 = { class: "segment-sub" }
const _hoisted_67 = { class: "hourly-block" }
const _hoisted_68 = { class: "hourly-head" }
const _hoisted_69 = {
  key: 0,
  class: "off-hours-pill"
}
const _hoisted_70 = { class: "hourly-chart" }
const _hoisted_71 = { class: "y-axis hourly-y" }
const _hoisted_72 = { class: "hourly-bars" }
const _hoisted_73 = ["onMouseenter"]
const _hoisted_74 = { class: "hour-label" }
const _hoisted_75 = { class: "panel" }
const _hoisted_76 = { class: "panel-head static" }
const _hoisted_77 = { class: "panel-title" }
const _hoisted_78 = { class: "title-with-sub" }
const _hoisted_79 = { class: "desc" }
const _hoisted_80 = { style: {"display":"flex","gap":"8px","align-items":"center"} }
const _hoisted_81 = { class: "uu-mode-toggle" }
const _hoisted_82 = { class: "panel-body" }
const _hoisted_83 = {
  key: 0,
  class: "inline-loader"
}
const _hoisted_84 = {
  key: 1,
  class: "empty"
}
const _hoisted_85 = {
  class: "chart-legend",
  style: {"min-height":"28px","margin-bottom":"8px"}
}
const _hoisted_86 = {
  key: 0,
  class: "lg-item"
}
const _hoisted_87 = {
  key: 1,
  class: "lg-item"
}
const _hoisted_88 = {
  key: 2,
  class: "lg-tooltip"
}
const _hoisted_89 = {
  key: 0,
  class: "lg-tooltip-new"
}
const _hoisted_90 = { class: "chart-with-axes" }
const _hoisted_91 = { class: "y-axis" }
const _hoisted_92 = { class: "chart-area" }
const _hoisted_93 = ["onMouseenter"]
const _hoisted_94 = {
  key: 0,
  class: "cumul-line-overlay"
}
const _hoisted_95 = {
  class: "cumul-svg-overlay",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_96 = ["d"]
const _hoisted_97 = ["d"]
const _hoisted_98 = {
  key: 1,
  class: "bar-chart"
}
const _hoisted_99 = ["onMouseenter"]
const _hoisted_100 = { class: "bar-value" }
const _hoisted_101 = { class: "bar-x-axis" }
const _hoisted_102 = {
  key: 1,
  class: "map-tab-container"
}

import { ref, reactive, computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  Loading,
  OfficeBuilding,
  User as UserIcon,
  Van,
  Money,
  Timer,
  Odometer,
} from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'

import CommonError from '@/components/CommonError.vue'
import EVTripPoints from './EVTripPoints.vue'
import {
  getEvStatistics,
  getEvTripIntervals,
  getEvTimeOfDay,
  getEvUniqueUsersDynamics,
  type EvStatistics,
  type EvStatisticsRangeMeta,
  type EvTripIntervals,
  type EvTimeOfDay,
  type EvUniqueUsersDynamics,
  type TripIntervalsGrouping,
  type TimeOfDaySegmentKey,
  type GetEvStatisticsParams,
} from '@/api/car-ev-data'
import { useAuthStore } from '@/store/auth'

interface IntervalBar {
  label: string
  shortDate: string
  value: number
  count: number
  heightPct: number
  above: boolean
  shortValue: string
  showLabel: boolean
}

const EXCLUDED_COLOR = '#94a3b8'
interface UniqueUsersBar {
  label: string
  shortDate: string
  fullDate: string
  value: number
  heightPct: number
  showLabel: boolean
  cumulativeValue: number
  cumulativeHeightPct: number
}

interface HourBar {
  hour: number
  trips: number
  color: string
  excluded: boolean
  segmentLabel: string
  heightPct: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EVStatistic',
  setup(__props) {

const authStore = useAuthStore()

// Check if current user is statistics-viewer (restricted access)
const isStatisticsViewer = computed(() => {
  const currentUser = authStore.session?.user
  return currentUser?.role === 'statistics-viewer' || currentUser?.ev_role === 'statistics-viewer'
})

const handleLogout = () => {
  authStore.signOut()
}

const route = useRoute()
const router = useRouter()

const normalizeStatTab = (val: unknown): 'main' | 'map' => {
  const s = Array.isArray(val) ? val[0] : String(val ?? '')
  if (s === 'main' || s === 'map') return s
  const saved = localStorage.getItem('ev-statistics-active-tab')
  if (saved === 'main' || saved === 'map') return saved
  return 'main'
}

const activeTab = ref<'main' | 'map'>(normalizeStatTab(route.query.tab))

// URL -> UI
watch(
  () => route.query.tab,
  (q) => {
    const next = normalizeStatTab(q)
    if (next !== activeTab.value) activeTab.value = next
  }
)

// UI -> URL & localStorage
watch(
  activeTab,
  (t) => {
    localStorage.setItem('ev-statistics-active-tab', t)
    const current = Array.isArray(route.query.tab) ? route.query.tab[0] : route.query.tab
    if (current !== t) {
      router.replace({ path: route.path, query: { ...route.query, tab: t } })
    }
  },
  { immediate: true }
)

/* -------- state -------- */
const loading = reactive({
  overview: false,
  intervals: false,
  timeOfDay: false,
  uniqueUsers: false,
})
const error = ref<string | null>(null)

const overview = ref<EvStatistics | null>(null)
const meta = ref<EvStatisticsRangeMeta | null>(null)

const intervals = ref<EvTripIntervals | null>(null)
const intervalsGrouping = ref<TripIntervalsGrouping>('daily')

const timeOfDay = ref<EvTimeOfDay | null>(null)
const timeOfDayMeta = ref<{ timezone?: string } | null>(null)

const uniqueUsers = ref<EvUniqueUsersDynamics | null>(null)
const uniqueUsersGrouping = ref<TripIntervalsGrouping>('daily')
const uniqueUsersChartMode = ref<'cumulative' | 'bar'>('cumulative')

const uniqueUsersPeriodLabel = computed(() => {
  if (uniqueUsersGrouping.value === 'monthly') return 'this month'
  if (uniqueUsersGrouping.value === 'weekly') return 'this week'
  return 'today'
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rangeModel = ref<[string, string] | null>(null) as any
const activePreset = ref<string>('all')

/* -------- presets -------- */
const presets = [
  { key: 'today', label: 'Today' },
  { key: '7d', label: '7d' },
  { key: '30d', label: '30d' },
  { key: 'month', label: 'Month' },
  { key: 'year', label: 'Year' },
  { key: 'all', label: 'All' },
] as const

const applyPreset = (key: string) => {
  activePreset.value = key
  const today = dayjs()
  switch (key) {
    case 'today':
      rangeModel.value = [today.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')]
      break
    case '7d':
      rangeModel.value = [today.subtract(6, 'day').format('YYYY-MM-DD'), today.format('YYYY-MM-DD')]
      break
    case '30d':
      rangeModel.value = [today.subtract(29, 'day').format('YYYY-MM-DD'), today.format('YYYY-MM-DD')]
      break
    case 'month':
      rangeModel.value = [today.startOf('month').format('YYYY-MM-DD'), today.endOf('month').format('YYYY-MM-DD')]
      break
    case 'year':
      rangeModel.value = [today.startOf('year').format('YYYY-MM-DD'), today.endOf('year').format('YYYY-MM-DD')]
      break
    case 'all':
    default:
      rangeModel.value = null
  }
  reloadAll()
}

const onRangeChanged = () => {
  activePreset.value = 'custom'
}

/* -------- formatting -------- */
const formatCurrency = (value?: number | null): string => {
  const n = Number(value ?? 0)
  const [int, frac = '00'] = n.toFixed(2).split('.')
  const withSpaces = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return frac === '00' ? `${withSpaces} ₼` : `${withSpaces}.${frac} ₼`
}

const formatNumber = (v?: number | null): string => {
  const n = Number(v ?? 0)
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

const formatMinutes = (v?: number | null): string => {
  const n = Math.round(Number(v ?? 0))
  if (n < 60) return `${n}m`
  const h = Math.floor(n / 60)
  const m = n % 60
  return m === 0 ? `${h}h` : `${h}h ${m}m`
}

const formatDateShort = (iso?: string) => {
  if (!iso) return ''
  return dayjs(iso).format('DD MMM YYYY')
}

/* -------- params -------- */
const currentParams = (): GetEvStatisticsParams => {
  const [from, to] = rangeModel.value || []
  const p: GetEvStatisticsParams = {}
  if (from) p.date_from = from
  if (to) p.date_to = to
  return p
}

const validateRange = (): boolean => {
  const [from, to] = rangeModel.value || []
  if (from && to && dayjs(from).isAfter(dayjs(to))) {
    ElMessage.error('Start date cannot be after end date')
    return false
  }
  return true
}

/* -------- loaders -------- */
const loadOverview = async () => {
  try {
    loading.overview = true
    error.value = null
    const res = await getEvStatistics(currentParams())
    overview.value = res?.data ?? {}
    meta.value = res?.meta ?? null
  } catch (e: unknown) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = e as any
    const msg = err?.response?.data?.message || err?.message || 'Failed to load statistics'
    error.value = msg
    ElMessage.error(msg)
  } finally {
    loading.overview = false
  }
}

const loadIntervals = async (force = false) => {
  if (!force && intervals.value) return
  try {
    loading.intervals = true
    const res = await getEvTripIntervals({
      ...currentParams(),
      grouping: intervalsGrouping.value,
    })
    intervals.value = res?.data ?? null
  } catch (e: unknown) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = e as any
    ElMessage.error(err?.response?.data?.message || err?.message || 'Failed to load intervals')
  } finally {
    loading.intervals = false
  }
}

const loadTimeOfDay = async (force = false) => {
  if (!force && timeOfDay.value) return
  try {
    loading.timeOfDay = true
    const res = await getEvTimeOfDay(currentParams())
    timeOfDay.value = res?.data ?? null
    timeOfDayMeta.value = res?.meta ?? null
  } catch (e: unknown) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = e as any
    ElMessage.error(err?.response?.data?.message || err?.message || 'Failed to load time of day')
  } finally {
    loading.timeOfDay = false
  }
}

const loadUniqueUsers = async (force = false) => {
  if (!force && uniqueUsers.value) return
  try {
    loading.uniqueUsers = true
    const res = await getEvUniqueUsersDynamics({
      ...currentParams(),
      grouping: uniqueUsersGrouping.value,
    })
    uniqueUsers.value = res?.data ?? null
  } catch (e: unknown) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = e as any
    ElMessage.error(err?.response?.data?.message || err?.message || 'Failed to load unique users')
  } finally {
    loading.uniqueUsers = false
  }
}

const reloadAll = () => {
  if (!validateRange()) return
  loadOverview()
  loadIntervals(true)
  loadTimeOfDay(true)
  loadUniqueUsers(true)
}

/* -------- KPI -------- */
const kpiList = computed(() => {
  const s = overview.value || {}
  return [
    {
      key: 'vehicles',
      title: 'Vehicles',
      value: formatNumber(s.totalVehicles),
      icon: Van,
      color: '#6366f1',
    },
    {
      key: 'users',
      title: 'Active EV users',
      value: formatNumber(s.totalUsers),
      icon: UserIcon,
      color: '#0ea5e9',
    },
    {
      key: 'unique-users',
      title: 'Unique Users',
      value: formatNumber(s.uniqueUsers),
      icon: UserIcon,
      color: '#06b6d4',
    },
    {
      key: 'trips',
      title: 'Finished trips',
      value: formatNumber(s.totalTrips),
      icon: OfficeBuilding,
      color: '#10b981',
    },
    {
      key: 'ongoing-trips',
      title: 'Ongoing trips',
      value: formatNumber(s.ongoingTrips),
      icon: OfficeBuilding,
      color: '#14b8a6',
    },
    {
      key: 'revenue',
      title: 'Revenue',
      value: formatCurrency(s.revenue),
      icon: Money,
      color: '#f59e0b',
    },
    {
      key: 'avg-duration',
      title: 'Avg trip duration',
      value: formatMinutes(s.avgTripDurationMinutes),
      icon: Timer,
      color: '#ec4899',
      hint: 'without pauses',
    },
    {
      key: 'avg-distance',
      title: 'Avg trip distance',
      value: `${(Number(s.avgTripDistanceKm ?? 0)).toFixed(2)} km`,
      icon: Odometer,
      color: '#8b5cf6',
    },
  ]
})

/* -------- Intervals chart (bars) -------- */
const hoveredBar = ref<(IntervalBar & { index: number }) | null>(null)

const hoveredBarDeltaPct = computed(() => {
  const avg = intervals.value?.avgIntervalMinutes || 0
  const v = hoveredBar.value?.value || 0
  if (!avg) return 0
  return Math.round(((v - avg) / avg) * 100)
})

const intervalsMaxY = computed(() => {
  const buckets = intervals.value?.buckets ?? []
  if (!buckets.length) return 1
  return Math.max(...buckets.map(b => b.avg_interval_minutes || 0), 1)
})

const intervalsYTicks = computed(() => {
  const max = intervalsMaxY.value
  return [1, 0.75, 0.5, 0.25, 0].map(r => formatMinutes(max * r))
})

const avgLinePct = computed(() => {
  const max = intervalsMaxY.value
  const avg = intervals.value?.avgIntervalMinutes ?? 0
  if (!max) return 0
  return Math.min(100, (avg / max) * 100)
})

const formatShortMinutes = (v: number): string => {
  const n = Math.round(v)
  if (n < 60) return `${n}m`
  const h = Math.floor(n / 60)
  const m = n % 60
  if (m === 0) return `${h}h`
  return `${h}h${m}`
}

const formatBucketShortDate = (raw: string): string => {
  const d = dayjs(raw)
  if (!d.isValid()) return raw
  if (intervalsGrouping.value === 'monthly') return d.format('MMM YY')
  if (intervalsGrouping.value === 'weekly') {
    const end = d.add(6, 'day')
    const sameMonth = d.format('MMM') === end.format('MMM')
    return sameMonth
      ? `${d.format('DD')}–${end.format('DD MMM')}`
      : `${d.format('DD MMM')}–${end.format('DD MMM')}`
  }
  return d.format('DD MMM')
}

const intervalBars = computed<IntervalBar[]>(() => {
  const buckets = intervals.value?.buckets ?? []
  if (!buckets.length) return []
  const max = intervalsMaxY.value
  const avg = intervals.value?.avgIntervalMinutes ?? 0
  const n = buckets.length
  // show at most ~10 labels to avoid overlap
  const labelStep = Math.max(1, Math.ceil(n / 10))
  return buckets.map((b, i) => {
    const v = b.avg_interval_minutes || 0
    return {
      label: formatBucketShortDate(b.date),
      shortDate: formatBucketShortDate(b.date),
      value: v,
      count: b.intervals_count || 0,
      heightPct: max ? Math.max(2, (v / max) * 100) : 0,
      above: v >= avg,
      shortValue: formatShortMinutes(v),
      showLabel: i % labelStep === 0 || i === n - 1,
    }
  })
})

/* -------- Time of day derived -------- */
const SEGMENT_COLORS: Record<TimeOfDaySegmentKey, string> = {
  morning: '#fbbf24',
  afternoon: '#10b981',
  evening: '#6366f1',
}
const SEGMENT_LABELS: Record<TimeOfDaySegmentKey, string> = {
  morning: 'Morning (6–11)',
  afternoon: 'Afternoon (12–16)',
  evening: 'Evening (17–22)',
}

const SEGMENT_KEYS: TimeOfDaySegmentKey[] = ['morning', 'afternoon', 'evening']

const hoveredUniqueUserBar = ref<(UniqueUsersBar & { index: number }) | null>(null)

const uniqueUsersMaxY = computed(() => {
  const buckets = uniqueUsers.value?.buckets ?? []
  if (!buckets.length) return 1
  return Math.max(...buckets.map(b => b.unique_users || 0), 1)
})

const uniqueUsersYTicks = computed(() => {
  const max = uniqueUsersMaxY.value
  const step = Math.max(1, Math.ceil(max / 4))
  const top = step * 4
  return [top, top - step, top - 2 * step, top - 3 * step, 0]
})

const uniqueUsersCumulativeYTicks = computed(() => {
  const max = uniqueUsersCumulativeMax.value
  const step = Math.max(1, Math.ceil(max / 4))
  const top = step * 4
  return [top, top - step, top - 2 * step, top - 3 * step, 0]
})

const formatBucketShortDateForUniqueUsers = (raw: string): string => {
  const d = dayjs(raw)
  if (!d.isValid()) return raw
  if (uniqueUsersGrouping.value === 'monthly') return d.format('MMM YY')
  if (uniqueUsersGrouping.value === 'weekly') {
    const end = d.add(6, 'day')
    const sameMonth = d.format('MMM') === end.format('MMM')
    return sameMonth
      ? `${d.format('DD')}–${end.format('DD MMM')}`
      : `${d.format('DD MMM')}–${end.format('DD MMM')}`
  }
  return d.format('DD MMM')
}

const formatBucketFullDateForUniqueUsers = (raw: string): string => {
  const d = dayjs(raw)
  if (!d.isValid()) return raw
  if (uniqueUsersGrouping.value === 'monthly') return d.format('MMMM YYYY')
  if (uniqueUsersGrouping.value === 'weekly') {
    const end = d.add(6, 'day')
    const sameMonth = d.format('MMM YYYY') === end.format('MMM YYYY')
    return sameMonth
      ? `${d.format('DD')}–${end.format('DD MMM YYYY')}`
      : `${d.format('DD MMM')}–${end.format('DD MMM YYYY')}`
  }
  return d.format('DD MMM YYYY')
}

const uniqueUsersCumulativeMax = computed(() => {
  const buckets = uniqueUsers.value?.buckets ?? []
  if (!buckets.length) return 1
  let running = 0
  for (const b of buckets) running += b.unique_users || 0
  return Math.max(running, 1)
})

const uniqueUsersBars = computed<UniqueUsersBar[]>(() => {
  const buckets = uniqueUsers.value?.buckets ?? []
  if (!buckets.length) return []
  const max = uniqueUsersMaxY.value || 1
  const cumulMax = uniqueUsersCumulativeMax.value || 1
  const n = buckets.length
  // show at most ~10 labels to avoid overlap
  const labelStep = Math.max(1, Math.ceil(n / 10))
  let running = 0
  return buckets.map((b, i) => {
    const v = b.unique_users || 0
    running += v
    return {
      label: formatBucketShortDateForUniqueUsers(b.date),
      shortDate: formatBucketShortDateForUniqueUsers(b.date),
      fullDate: formatBucketFullDateForUniqueUsers(b.date),
      value: v,
      heightPct: max ? Math.max(1, (v / max) * 100) : 0,
      showLabel: i % labelStep === 0 || i === n - 1,
      cumulativeValue: running,
      cumulativeHeightPct: cumulMax ? (running / cumulMax) * 100 : 0,
    }
  })
})

// Generates a smooth SVG path (cubic bezier) for the cumulative line.
// X uses i/(n-1) so the line spans the full width (0% → 100%).
// viewBox 0 0 100 100, preserveAspectRatio=none
const uniqueUsersCumulativePolyline = computed(() => {
  const bars = uniqueUsersBars.value
  if (bars.length < 2) return ''
  const n = bars.length
  const pts = bars.map((b, i) => ({
    x: (i / (n - 1)) * 100,
    y: 100 - b.cumulativeHeightPct,
  }))
  // Build smooth cubic bezier path
  let d = `M${pts[0].x.toFixed(2)},${pts[0].y.toFixed(2)}`
  for (let i = 1; i < pts.length; i++) {
    const prev = pts[i - 1]
    const curr = pts[i]
    const cpx = (prev.x + curr.x) / 2
    d += ` C${cpx.toFixed(2)},${prev.y.toFixed(2)} ${cpx.toFixed(2)},${curr.y.toFixed(2)} ${curr.x.toFixed(2)},${curr.y.toFixed(2)}`
  }
  return d
})

const totalTodTrips = computed(() => {
  const s = timeOfDay.value?.segments
  if (!s) return 0
  return SEGMENT_KEYS.reduce((acc, k) => acc + (s[k]?.trips || 0), 0)
})

const excludedTrips = computed(() => timeOfDay.value?.excluded?.trips || 0)
const excludedHoursRange = computed(
  () => timeOfDay.value?.excluded?.hours_range || '23:00–05:59'
)

const segmentList = computed(() => {
  const s = timeOfDay.value?.segments
  if (!s) return []
  const total = totalTodTrips.value || 1
  return SEGMENT_KEYS.map(k => ({
    key: k,
    label: SEGMENT_LABELS[k],
    color: SEGMENT_COLORS[k],
    trips: s[k]?.trips || 0,
    revenue: s[k]?.revenue || 0,
    avg_duration_minutes: s[k]?.avg_duration_minutes || 0,
    avg_distance_km: s[k]?.avg_distance_km || 0,
    percent: Math.round(((s[k]?.trips || 0) / total) * 100),
  }))
})

const donutGradient = computed(() => {
  const segs = segmentList.value
  const total = totalTodTrips.value || 1
  let acc = 0
  const stops: string[] = []
  segs.forEach(s => {
    const start = (acc / total) * 360
    acc += s.trips
    const end = (acc / total) * 360
    stops.push(`${s.color} ${start}deg ${end}deg`)
  })
  return `conic-gradient(${stops.join(', ') || '#e5e7eb 0deg 360deg'})`
})

const hourlyMax = computed(() => {
  const hourly = timeOfDay.value?.hourly ?? []
  return Math.max(1, ...hourly.map(h => h.trips || 0))
})

const hourlyYTicks = computed(() => {
  const max = hourlyMax.value
  // pick a "nice" integer step so we never show duplicate ticks like [1,1,1,0,0]
  const niceStep = (m: number): number => {
    if (m <= 4) return 1
    if (m <= 10) return 2
    if (m <= 25) return 5
    if (m <= 50) return 10
    if (m <= 100) return 20
    const pow = Math.pow(10, Math.floor(Math.log10(m)))
    return Math.ceil(m / 5 / pow) * pow
  }
  const step = niceStep(max)
  const top = Math.ceil(max / step) * step
  const ticks: string[] = []
  for (let v = top; v >= 0; v -= step) ticks.push(formatNumber(v))
  return ticks
})

const hourlyNormalized = computed<HourBar[]>(() => {
  const hourly = timeOfDay.value?.hourly ?? []
  const map = new Map<number, number>()
  hourly.forEach(h => map.set(h.hour, h.trips))
  // normalize against the top tick so bar heights match grid lines
  const top = Math.max(1, parseInt(hourlyYTicks.value[0] || '1', 10) || hourlyMax.value)
  return Array.from({ length: 24 }, (_, hour) => {
    const trips = map.get(hour) ?? 0
    let color = EXCLUDED_COLOR
    let excluded = true
    let segmentLabel = 'Off-hours'
    if (hour >= 6 && hour <= 11) {
      color = SEGMENT_COLORS.morning; excluded = false; segmentLabel = 'Morning'
    } else if (hour >= 12 && hour <= 16) {
      color = SEGMENT_COLORS.afternoon; excluded = false; segmentLabel = 'Afternoon'
    } else if (hour >= 17 && hour <= 22) {
      color = SEGMENT_COLORS.evening; excluded = false; segmentLabel = 'Evening'
    }
    return {
      hour,
      trips,
      color,
      excluded,
      segmentLabel,
      heightPct: trips > 0 ? Math.max(3, (trips / top) * 100) : 0,
    }
  })
})

const hoveredHour = ref<HourBar | null>(null)

const totalTodTripsInc = computed(() => totalTodTrips.value + excludedTrips.value)

const hoveredHourPct = computed(() => {
  const tot = totalTodTripsInc.value
  if (!tot || !hoveredHour.value) return 0
  return Math.round((hoveredHour.value.trips / tot) * 100)
})

// pull tooltip toward the inside of the chart when near the edges
const tooltipAlignClass = (hour: number) => {
  if (hour <= 2) return 'tt-align-left'
  if (hour >= 21) return 'tt-align-right'
  return 'tt-align-center'
}

/* -------- lifecycle -------- */
onMounted(() => {
  loadOverview()
  loadIntervals(true)
  loadTimeOfDay(true)
  loadUniqueUsers(true)
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ev-statistics", { 'is-map-view': activeTab.value === 'map' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (isStatisticsViewer.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: handleLogout,
            class: "action-btn danger sign-out-button"
          }, " Sign out "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[16] || (_cache[16] = _createElementVNode("h2", null, "EV Statistics", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _cache[15] || (_cache[15] = _createTextVNode(" Usage, revenue and behavioural insights ")),
              (meta.value?.range?.date_from)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[13] || (_cache[13] = _createTextVNode(" · ")),
                    _createElementVNode("b", null, _toDisplayString(formatDateShort(meta.value.range.date_from)), 1),
                    _cache[14] || (_cache[14] = _createTextVNode(" — ")),
                    _createElementVNode("b", null, _toDisplayString(formatDateShort(meta.value.range.date_to)), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(["tab-btn", { active: activeTab.value === 'main' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'main'))
              }, " Main statistics ", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["tab-btn", { active: activeTab.value === 'map' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'map'))
              }, " Map ", 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presets, (p) => {
                return _createElementVNode("button", {
                  key: p.key,
                  class: _normalizeClass(["preset-btn", { active: activePreset.value === p.key }]),
                  disabled: loading.overview,
                  onClick: ($event: any) => (applyPreset(p.key))
                }, _toDisplayString(p.label), 11, _hoisted_10)
              }), 64))
            ]),
            _createVNode(_component_el_date_picker, {
              modelValue: rangeModel.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rangeModel).value = $event)),
              type: "daterange",
              "unlink-panels": "",
              "popper-class": "ev-stats-popper",
              "range-separator": "→",
              "start-placeholder": "From",
              "end-placeholder": "To",
              "value-format": "YYYY-MM-DD",
              format: "YYYY-MM-DD",
              size: "small",
              style: {"width":"260px"},
              onChange: onRangeChanged
            }, null, 8, ["modelValue"]),
            _createElementVNode("button", {
              class: "action-btn primary",
              disabled: loading.overview,
              onClick: reloadAll
            }, _toDisplayString(loading.overview ? 'Applying...' : 'Apply'), 9, _hoisted_11)
          ])
        ])
      ])
    ]),
    (error.value)
      ? (_openBlock(), _createBlock(CommonError, {
          key: 0,
          errorMessage: error.value,
          onRetryPress: reloadAll
        }, null, 8, ["errorMessage"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      (overview.value || loading.overview)
        ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiList.value, (kpi) => {
              return (_openBlock(), _createElementBlock("div", {
                key: kpi.key,
                class: "kpi-card",
                style: _normalizeStyle({ '--accent': kpi.color })
              }, [
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(kpi.icon)))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createTextVNode(_toDisplayString(kpi.title) + " ", 1),
                    (kpi.hint)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "(" + _toDisplayString(kpi.hint) + ")", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (loading.overview)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("—")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(kpi.value), 1)
                        ], 64))
                  ])
                ])
              ], 4))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_18, [
        _createElementVNode("header", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[20] || (_cache[20] = _createElementVNode("h3", null, "Intervals between trips", -1)),
              _createElementVNode("small", _hoisted_22, [
                _cache[17] || (_cache[17] = _createTextVNode(" Time gap between consecutive finished trips across the fleet. Tiles below summarise ")),
                _cache[18] || (_cache[18] = _createElementVNode("b", null, "all", -1)),
                _cache[19] || (_cache[19] = _createTextVNode(" intervals (avg / median / min / max / total count). Chart shows ")),
                _createElementVNode("b", null, "average interval length per " + _toDisplayString(intervalsGrouping.value === 'monthly'
                      ? 'month'
                      : intervalsGrouping.value === 'weekly'
                      ? 'week'
                      : 'day'), 1),
                _createTextVNode(" — so its Y-axis maxes out at the biggest per-" + _toDisplayString(intervalsGrouping.value === 'monthly'
                    ? 'month'
                    : intervalsGrouping.value === 'weekly'
                    ? 'week'
                    : 'day') + " average, not the single longest interval. ", 1)
              ])
            ]),
            _createVNode(_component_el_select, {
              modelValue: intervalsGrouping.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((intervalsGrouping).value = $event)),
              size: "small",
              style: {"width":"110px"},
              onChange: _cache[4] || (_cache[4] = ($event: any) => (loadIntervals(true)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Daily",
                  value: "daily"
                }),
                _createVNode(_component_el_option, {
                  label: "Weekly",
                  value: "weekly"
                }),
                _createVNode(_component_el_option, {
                  label: "Monthly",
                  value: "monthly"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          (loading.intervals)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_el_icon, { class: "is-loading" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Loading))
                  ]),
                  _: 1
                }),
                _cache[21] || (_cache[21] = _createElementVNode("span", null, "Loading intervals…", -1))
              ]))
            : (intervals.value && intervals.value.intervalsCount === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, " No intervals in the selected range — either there are no trips, or each day has only a single trip (intervals need at least 2 trips per day). "))
              : (intervals.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", null, "Avg", -1)),
                        _createElementVNode("b", null, _toDisplayString(formatMinutes(intervals.value.avgIntervalMinutes)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _cache[23] || (_cache[23] = _createElementVNode("span", null, "Median", -1)),
                        _createElementVNode("b", null, _toDisplayString(formatMinutes(intervals.value.medianIntervalMinutes)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[24] || (_cache[24] = _createElementVNode("span", null, "Min", -1)),
                        _createElementVNode("b", null, _toDisplayString(formatMinutes(intervals.value.minIntervalMinutes)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[25] || (_cache[25] = _createElementVNode("span", null, "Max", -1)),
                        _createElementVNode("b", null, _toDisplayString(formatMinutes(intervals.value.maxIntervalMinutes)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _cache[26] || (_cache[26] = _createElementVNode("span", null, "Intervals", -1)),
                        _createElementVNode("b", null, _toDisplayString(formatNumber(intervals.value.intervalsCount)), 1)
                      ])
                    ]),
                    (intervals.value.buckets && intervals.value.buckets.length === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, " Single " + _toDisplayString(intervalsGrouping.value) + " bucket ", 1),
                            _createElementVNode("div", _hoisted_35, _toDisplayString(intervals.value.buckets[0].date), 1),
                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "sb-sub" }, [
                              _createTextVNode(" Not enough periods to draw a trend — try a wider date range or finer grouping (e.g. "),
                              _createElementVNode("b", null, "Daily"),
                              _createTextVNode("). ")
                            ], -1))
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("span", null, _toDisplayString(formatMinutes(intervals.value.buckets[0].avg_interval_minutes)), 1),
                            _createElementVNode("small", null, _toDisplayString(intervals.value.buckets[0].intervals_count) + " intervals", 1)
                          ])
                        ]))
                      : (intervals.value.buckets?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _cache[29] || (_cache[29] = _createElementVNode("span", { class: "lg-item" }, [
                                _createElementVNode("span", { class: "lg-bar lg-bar-lo" }),
                                _createTextVNode(" Below average ")
                              ], -1)),
                              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "lg-item" }, [
                                _createElementVNode("span", { class: "lg-bar lg-bar-hi" }),
                                _createTextVNode(" Above average ")
                              ], -1)),
                              _createElementVNode("span", _hoisted_39, [
                                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "lg-dash" }, null, -1)),
                                _createTextVNode(" Period average (" + _toDisplayString(formatMinutes(intervals.value.avgIntervalMinutes)) + ") ", 1)
                              ]),
                              (hoveredBar.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                    _createElementVNode("b", null, _toDisplayString(hoveredBar.value.label), 1),
                                    _createTextVNode(" · " + _toDisplayString(formatMinutes(hoveredBar.value.value)) + " ", 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["lg-delta", hoveredBar.value.above ? 'delta-up' : 'delta-down'])
                                    }, _toDisplayString(hoveredBar.value.above ? '▲' : '▼') + " " + _toDisplayString(hoveredBarDeltaPct.value) + "% vs avg ", 3),
                                    _createTextVNode(" · " + _toDisplayString(hoveredBar.value.count) + " intervals ", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, " Avg per " + _toDisplayString(intervalsGrouping.value === 'monthly'
                        ? 'month'
                        : intervalsGrouping.value === 'weekly'
                        ? 'week'
                        : 'day'), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervalsYTicks.value, (t, i) => {
                                  return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(t), 1))
                                }), 128))
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("div", {
                                    class: "avg-line",
                                    style: _normalizeStyle({ bottom: avgLinePct.value + '%' })
                                  }, [
                                    _createElementVNode("span", _hoisted_46, " avg " + _toDisplayString(formatMinutes(intervals.value.avgIntervalMinutes)), 1)
                                  ], 4),
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                                    return _createElementVNode("div", {
                                      key: `g${i}`,
                                      class: "grid-line",
                                      style: _normalizeStyle({ bottom: i * 25 + '%' })
                                    }, null, 4)
                                  }), 64)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervalBars.value, (bar, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: i,
                                      class: _normalizeClass(["bar-col", { hovered: hoveredBar.value?.index === i }]),
                                      onMouseenter: ($event: any) => (hoveredBar.value = { ...bar, index: i }),
                                      onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (hoveredBar.value = null))
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["bar", bar.above ? 'bar-hi' : 'bar-lo']),
                                        style: _normalizeStyle({ height: bar.heightPct + '%' })
                                      }, [
                                        _createElementVNode("span", _hoisted_48, _toDisplayString(bar.shortValue), 1)
                                      ], 6)
                                    ], 42, _hoisted_47))
                                  }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervalBars.value, (bar, i) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: i,
                                      class: _normalizeClass({ hide: !bar.showLabel })
                                    }, _toDisplayString(bar.shortDate), 3))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_50, "No data for selected range"))
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_51, "Open to load data"))
        ])
      ]),
      _createElementVNode("section", _hoisted_52, [
        _createElementVNode("header", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _cache[35] || (_cache[35] = _createElementVNode("h3", null, "Time of day distribution", -1)),
              _createElementVNode("small", _hoisted_56, [
                _cache[32] || (_cache[32] = _createTextVNode(" Share of finished trips by segment of the day ")),
                (timeOfDayMeta.value?.timezone)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[31] || (_cache[31] = _createTextVNode(" · TZ ")),
                      _createElementVNode("b", null, _toDisplayString(timeOfDayMeta.value.timezone), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _cache[33] || (_cache[33] = _createTextVNode(" · Y axis — ")),
                _cache[34] || (_cache[34] = _createElementVNode("b", null, "trips", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          (loading.timeOfDay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _createVNode(_component_el_icon, { class: "is-loading" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Loading))
                  ]),
                  _: 1
                }),
                _cache[36] || (_cache[36] = _createElementVNode("span", null, "Loading time of day…", -1))
              ]))
            : (timeOfDay.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", {
                      class: "donut",
                      style: _normalizeStyle({ background: donutGradient.value })
                    }, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("span", _hoisted_62, _toDisplayString(totalTodTrips.value), 1),
                        _cache[37] || (_cache[37] = _createElementVNode("span", { class: "donut-label" }, "trips", -1))
                      ])
                    ], 4),
                    _createElementVNode("div", _hoisted_63, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segmentList.value, (s) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: s.key,
                          class: "segment-item"
                        }, [
                          _createElementVNode("span", {
                            class: "segment-swatch",
                            style: _normalizeStyle({ background: s.color })
                          }, null, 4),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("b", null, _toDisplayString(s.label), 1),
                              _createElementVNode("span", null, _toDisplayString(s.percent) + "%", 1)
                            ]),
                            _createElementVNode("div", _hoisted_66, _toDisplayString(s.trips) + " trips · " + _toDisplayString(formatCurrency(s.revenue)) + " · " + _toDisplayString(s.avg_duration_minutes.toFixed(1)) + "m avg ", 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "hourly-title" }, "Hourly breakdown", -1)),
                      (excludedTrips.value > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "oh-dot" }, null, -1)),
                            _createTextVNode(" Off-hours (" + _toDisplayString(excludedHoursRange.value) + "): ", 1),
                            _createElementVNode("b", null, _toDisplayString(formatNumber(excludedTrips.value)), 1),
                            _cache[39] || (_cache[39] = _createTextVNode(" trips "))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hourlyYTicks.value, (t, i) => {
                          return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(t), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hourlyNormalized.value, (h) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: h.hour,
                            class: _normalizeClass(["hour-col", {
                        'is-excluded': h.excluded,
                        hovered: hoveredHour.value?.hour === h.hour,
                      }]),
                            onMouseenter: ($event: any) => (hoveredHour.value = h),
                            onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (hoveredHour.value = null))
                          }, [
                            (hoveredHour.value?.hour === h.hour)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["hourly-tooltip", tooltipAlignClass(h.hour)])
                                }, [
                                  _createElementVNode("b", null, _toDisplayString(h.hour) + ":00 – " + _toDisplayString(h.hour) + ":59", 1),
                                  _createElementVNode("span", {
                                    class: "ht-seg",
                                    style: _normalizeStyle({ background: h.color })
                                  }, _toDisplayString(h.segmentLabel), 5),
                                  _cache[41] || (_cache[41] = _createTextVNode(" · ")),
                                  _createElementVNode("b", null, _toDisplayString(h.trips), 1),
                                  _cache[42] || (_cache[42] = _createTextVNode(" trips ")),
                                  (totalTodTripsInc.value > 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" · " + _toDisplayString(hoveredHourPct.value) + "% of total ", 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 2))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: "hour-bar",
                              style: _normalizeStyle({
                          height: h.heightPct + '%',
                          background: h.color,
                        })
                            }, null, 4),
                            _createElementVNode("span", _hoisted_74, _toDisplayString(h.hour), 1)
                          ], 42, _hoisted_73))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_75, [
        _createElementVNode("header", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _cache[45] || (_cache[45] = _createElementVNode("h3", null, "Unique users", -1)),
              _createElementVNode("small", _hoisted_79, [
                _cache[44] || (_cache[44] = _createTextVNode(" Dynamics of unique active users over time ")),
                (timeOfDayMeta.value?.timezone)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[43] || (_cache[43] = _createTextVNode(" · TZ ")),
                      _createElementVNode("b", null, _toDisplayString(timeOfDayMeta.value.timezone), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("button", {
                  class: _normalizeClass(["uu-mode-btn", { active: uniqueUsersChartMode.value === 'cumulative' }]),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (uniqueUsersChartMode.value = 'cumulative'))
                }, " Cumulative ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["uu-mode-btn", { active: uniqueUsersChartMode.value === 'bar' }]),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (uniqueUsersChartMode.value = 'bar'))
                }, " Bar ", 2)
              ]),
              _createVNode(_component_el_select, {
                modelValue: uniqueUsersGrouping.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((uniqueUsersGrouping).value = $event)),
                size: "small",
                style: {"width":"110px"},
                onChange: _cache[10] || (_cache[10] = ($event: any) => (loadUniqueUsers(true)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "Daily",
                    value: "daily"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Weekly",
                    value: "weekly"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Monthly",
                    value: "monthly"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_82, [
          (loading.uniqueUsers && !uniqueUsers.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _createVNode(_component_el_icon, { class: "is-loading" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Loading))
                  ]),
                  _: 1
                }),
                _cache[46] || (_cache[46] = _createElementVNode("span", null, "Loading unique users…", -1))
              ]))
            : (uniqueUsers.value && uniqueUsers.value.buckets.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, " No active users in the selected range "))
              : (uniqueUsers.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "chart-wrapper",
                    style: _normalizeStyle({
                marginTop: '10px',
                opacity: loading.uniqueUsers ? 0.5 : 1,
                pointerEvents: loading.uniqueUsers ? 'none' : 'auto',
                transition: 'opacity 0.2s',
              })
                  }, [
                    _createElementVNode("div", _hoisted_85, [
                      (uniqueUsersChartMode.value === 'cumulative')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_86, _cache[47] || (_cache[47] = [
                            _createElementVNode("span", { class: "lg-line-cumul" }, null, -1),
                            _createElementVNode("span", null, "Cumulative total", -1)
                          ])))
                        : (_openBlock(), _createElementBlock("span", _hoisted_87, _cache[48] || (_cache[48] = [
                            _createElementVNode("span", { class: "lg-bar lg-bar-hi" }, null, -1),
                            _createElementVNode("span", null, "New users per period", -1)
                          ]))),
                      (hoveredUniqueUserBar.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_88, [
                            _createElementVNode("b", null, _toDisplayString(hoveredUniqueUserBar.value.fullDate), 1),
                            _cache[51] || (_cache[51] = _createElementVNode("span", { class: "lg-tooltip-sep" }, "·", -1)),
                            (uniqueUsersChartMode.value === 'cumulative')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[49] || (_cache[49] = _createElementVNode("span", {
                                    class: "lg-line-cumul",
                                    style: {"width":"14px","flex-shrink":"0"}
                                  }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(hoveredUniqueUserBar.value.cumulativeValue), 1),
                                  (hoveredUniqueUserBar.value.value > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_89, "+" + _toDisplayString(hoveredUniqueUserBar.value.value) + " " + _toDisplayString(hoveredUniqueUserBar.value.index ===
                        uniqueUsersBars.value.length - 1
                          ? uniqueUsersPeriodLabel.value
                          : 'new'), 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[50] || (_cache[50] = _createElementVNode("span", {
                                    class: "lg-bar lg-bar-hi",
                                    style: {"display":"inline-block","width":"8px","height":"8px","border-radius":"2px","flex-shrink":"0"}
                                  }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(hoveredUniqueUserBar.value.value), 1)
                                ], 64))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueUsersChartMode.value === 'cumulative'
                      ? uniqueUsersCumulativeYTicks.value
                      : uniqueUsersYTicks.value, (t, i) => {
                          return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(t), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_92, [
                        (uniqueUsersChartMode.value === 'cumulative')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "bar-chart cumul-standalone",
                              onMouseleave: _cache[11] || (_cache[11] = ($event: any) => (hoveredUniqueUserBar.value = null))
                            }, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([25, 50, 75, 100], (line) => {
                                return _createElementVNode("div", {
                                  key: 'cg' + line,
                                  class: "grid-line",
                                  style: _normalizeStyle({ bottom: line + '%' })
                                }, null, 4)
                              }), 64)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueUsersBars.value, (b, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: 'ch' + i,
                                  class: _normalizeClass(["bar-col cumul-hover-col", { hovered: hoveredUniqueUserBar.value?.index === i }]),
                                  onMouseenter: ($event: any) => (hoveredUniqueUserBar.value = { ...b, index: i })
                                }, null, 42, _hoisted_93))
                              }), 128)),
                              (uniqueUsersCumulativePolyline.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_95, [
                                      _createElementVNode("path", {
                                        class: "cumul-area",
                                        d: 
                              uniqueUsersCumulativePolyline.value +
                                ' L100,100 L0,100 Z'
                            
                                      }, null, 8, _hoisted_96),
                                      _createElementVNode("path", {
                                        class: "cumul-line",
                                        d: uniqueUsersCumulativePolyline.value
                                      }, null, 8, _hoisted_97)
                                    ])),
                                    (
                            hoveredUniqueUserBar.value && uniqueUsersBars.value.length > 1
                          )
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "cumul-hover-dot",
                                          style: _normalizeStyle({
                            left:
                              (
                                (hoveredUniqueUserBar.value.index /
                                  (uniqueUsersBars.value.length - 1)) *
                                100
                              ).toFixed(2) + '%',
                            bottom:
                              hoveredUniqueUserBar.value.cumulativeHeightPct.toFixed(
                                2
                              ) + '%',
                          })
                                        }, null, 4))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 32))
                          : (_openBlock(), _createElementBlock("div", _hoisted_98, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([25, 50, 75, 100], (line) => {
                                return _createElementVNode("div", {
                                  key: 'bg' + line,
                                  class: "grid-line",
                                  style: _normalizeStyle({ bottom: line + '%' })
                                }, null, 4)
                              }), 64)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueUsersBars.value, (b, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: _normalizeClass(["bar-col", { hovered: hoveredUniqueUserBar.value?.index === i }]),
                                  onMouseenter: ($event: any) => (hoveredUniqueUserBar.value = { ...b, index: i }),
                                  onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (hoveredUniqueUserBar.value = null))
                                }, [
                                  _createElementVNode("div", _hoisted_100, _toDisplayString(b.value), 1),
                                  _createElementVNode("div", {
                                    class: "bar bar-hi",
                                    style: _normalizeStyle({ height: b.heightPct + '%' })
                                  }, null, 4)
                                ], 42, _hoisted_99))
                              }), 128))
                            ])),
                        _createElementVNode("div", _hoisted_101, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueUsersBars.value, (b, i) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 'xl' + i
                            }, _toDisplayString(b.showLabel ? b.shortDate : ''), 1))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 4))
                : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, activeTab.value === 'main']
    ]),
    (activeTab.value === 'map')
      ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
          _createVNode(EVTripPoints, {
            embedded: true,
            "date-from": meta.value?.range?.date_from,
            "date-to": meta.value?.range?.date_to
          }, null, 8, ["date-from", "date-to"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})